export function formatDate(inputDate) {
    const date = new Date(inputDate);
  
    const day = date.getDate(); // Get the day (1-31)
    const month = date.toLocaleString('default', { month: 'short' }); // Get the abbreviated month name (e.g., 'Sep')
    const year = date.getFullYear(); // Get the full year (e.g., 2023)
  
    // Create the formatted date string
    const formattedDate = `${day} ${month} ${year}`;
  
    return formattedDate;
  }